import axios, { AxiosError } from "axios";
import { BASE_API, NOT_CONNECTED_MESSAGE } from "../../utils/constants";

export class DataImportService {
    static readonly userCreationEndpoint = `${BASE_API}/user`;

    static userCreationColumns = [
        "branch",
        "card",
        "disabled",
        "group",
        "name",
        "password",
        "pin",
        "privilege",
        "verified",
    ];

    static async createBulkUsers(users: any[], org: any, api_key: any) {
        const cleanedUser = [];

        for (const user of users) {
            const clean: any = {};

            for (const col of this.userCreationColumns) {
                clean[col] = user[col];
            }

            cleanedUser.push(clean);
        }

        try {
            const response = await axios.post(
                this.userCreationEndpoint,
                cleanedUser,
                {
                    withCredentials: true,
                    headers: {
                        "x-org": org,
                        authorization: `Bearer ${api_key}`,
                    },
                }
            );
            return [response.data, null] as any;
        } catch (err: any) {
            return [
                null,
                (err as AxiosError).response?.data ?? {
                    message: NOT_CONNECTED_MESSAGE,
                },
            ] as any;
        }
    }
}
